var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monitor-wrap"},[_c('dv-scroll-board',{ref:"scrollBoard",attrs:{"config":_vm.tableConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }